import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zoom = defineConnector({
  identifier: "zoom",
  name: "Zoom",
  tagLine: "Video communications platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.zoom\\.us/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://zoom.us/oauth/token",
        method: "POST",
        formBody: {
          grant_type: "account_credentials",
          account_id: app.config.accountId,
        },
        basicAuth: {
          username: app.secret.clientId,
          password: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create a Server-to-Server OAuth app",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Zoom App Marketplace](https://marketplace.zoom.us/develop/create) and create a new **Server-to-Server OAuth** app.",
        },
      ],
    },
    {
      title: "Copy your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "From your app’s credentials page, copy the account ID, client ID, and client secret.",
        },
        {
          kind: "input",
          label: "Account ID",
          required: true,
          target: { kind: "configuration", field: "accountId" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.zoom.us/v2/users/me",
  },
});
